import React from "react";
import MedicationSidebarList from "./MedicationSidebarList";
import { drugTypes } from "../../service-steps/clinical-assessment/data";

const AdditionalMedicationsSection = ({
  filteredMedication,
  showAdditionalMeds,
  setShowAdditionalMeds,
  onMedicationClick,
  onMenuAction,
  onExpandMedication,
  expandedMedications,
  hoveredMed,
  onMouseEnter,
  onMouseLeave,
  menuMedication,
  onMenuOpen,
  showMenu,
  menuData,
  selectedMedication,
  isMatchingDrug,
  medicationDetails,
  getNoRecordMessage,
  isIntervention,
}) => {
  return (
    <MedicationSidebarList
      medications={filteredMedication?.filter(
        (x) => x.medicationType === drugTypes.Additional
      )}
      title="Additional Medications"
      isExpanded={showAdditionalMeds}
      onToggleExpanded={() => setShowAdditionalMeds(!showAdditionalMeds)}
      onMedicationClick={onMedicationClick}
      onMenuAction={onMenuAction}
      onExpandMedication={onExpandMedication}
      expandedMedications={expandedMedications}
      hoveredMed={hoveredMed}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      menuMedication={menuMedication}
      onMenuOpen={onMenuOpen}
      showMenu={showMenu}
      menuData={menuData}
      selectedMedication={selectedMedication}
      isMatchingDrug={isMatchingDrug}
      medicationDetails={medicationDetails}
      getNoRecordMessage={getNoRecordMessage}
      drugType={drugTypes.Additional}
      isIntervention={isIntervention}
    />
  );
};

export default AdditionalMedicationsSection;
